import React from 'react';
import PropTypes from 'prop-types';
import css from './HoursSection.scss';
import Title from 'common/Title';
import DayScheduleView from 'common/DayScheduleView';
import {tenantTimeZoneLongForm} from 'utils/tenant';
import {SFEntityID, SFVirtualCheckInDaySchedule} from 'utils/types';

export default class HoursSection extends React.Component {

  get hoursOfOperation() {
    return this.props.hoursOfOperation ?
      <div>
        <Title text="Service Hours" />
        <div className="hours-of-operation-div">{this.props.hoursOfOperation}</div>
      </div>
      : null;
  }

  get virtualKioskHours() {
    return this.props.virtualKioskSchedule && this.props.virtualKioskSchedule.length > 0 ?
        <div>
          <Title text="Virtual Check-in Hours" />
          <div className={css['virtual-kiosk-hours-text']}><span className={css['bolded']}>Join Waiting Room</span> online during these hours shown in time zone: {tenantTimeZoneLongForm()}</div>
            <div className={css['hours-of-operation-div']}>
              {this.props.virtualKioskSchedule.map((day, key) => <DayScheduleView key={key} day={day} />)}
            </div>
        </div>
        : null;
  }

  render() {
    return (
      <div className={css['hours-container']}>
        {this.hoursOfOperation}
        {this.virtualKioskHours}
      </div>
    );
  }
}

HoursSection.propTypes = {
  id: SFEntityID.isRequired,
  virtualKioskSchedule: PropTypes.arrayOf(SFVirtualCheckInDaySchedule),
  hoursOfOperation: PropTypes.string
};
